import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { ID } from "@types";
import { getSelectionRateMetrics } from "../services/serviceProviders";

export const useSelectionRate = (serviceProviderId: ID | undefined) => {
  const { data, isLoading, isError, isSuccess, status, refetch, error } =
    useDataQuery(
      ["selectionRate", Number(serviceProviderId)],
      async () => {
        const response = await getSelectionRateMetrics(serviceProviderId);
        return response.data;
      },
      { enabled: !!serviceProviderId }
    );

  return { data, isLoading, isError, isSuccess, status, error, refetch };
};
